import { z } from "zod";
import { CdtTreeMetaSchema } from "@CommonApi/cdt/trees/_treeId_/index";

export const RoutePutCdtCategories_categoryId_DefaultTree =
  "/cdt/categories/:categoryId/default-tree";

export const ParamsCdtCategoryDefaultTreeSchema = z.object({
  categoryId: z.coerce.number().int().positive(),
});

export const PutCategoryDefaultTreeBodySchema = z.object({
  treeId: z.number().int().positive(),
});

export const ResponsePutCategoryDefaultTreeSchema = CdtTreeMetaSchema;

export type ParamsCdtCategoryDefaultTree = z.infer<typeof ParamsCdtCategoryDefaultTreeSchema>;
export type PutCategoryDefaultTreeBody = z.infer<typeof PutCategoryDefaultTreeBodySchema>;
export type ResponsePutCategoryDefaultTree = z.infer<typeof ResponsePutCategoryDefaultTreeSchema>;
